module.exports = __webpack_public_path__ + "static/media/ab_notify_client_en_yl.900e73a2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ab_notify_client_en_yl.svg
// module id = 1260
// module chunks = 0